import { Check } from "lucide-react";
import type { InputHTMLAttributes, ReactNode } from "react";

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label: ReactNode;
  description?: ReactNode;
};

export function Checkbox({ label, description, className = "", ...props }: CheckboxProps) {
  return (
    <label
      className={`card-paper group flex min-h-12 items-start gap-3 p-4 text-sm leading-6 text-text-muted transition hover:border-accent-200 hover:bg-surface ${className}`}
    >
      <span className="relative mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center">
        <input
          className="peer h-5 w-5 appearance-none rounded-xs border border-border bg-surface-raised transition checked:border-accent-600 checked:bg-accent-600 focus-visible:outline-none focus-visible:shadow-[var(--shadow-ring-focus)]"
          type="checkbox"
          {...props}
        />
        <Check
          aria-hidden="true"
          className="pointer-events-none absolute h-3.5 w-3.5 scale-75 text-white opacity-0 transition peer-checked:scale-100 peer-checked:opacity-100"
        />
      </span>
      <span className="min-w-0">
        <span className="block text-text">{label}</span>
        {description ? <span className="mt-1 block text-text-muted">{description}</span> : null}
      </span>
    </label>
  );
}
